import { render, staticRenderFns } from "./RbVirtualList.vue?vue&type=template&id=42ff5c92&"
import script from "./RbVirtualList.vue?vue&type=script&lang=js&"
export * from "./RbVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports